'use client';

import { Grid, GridItem, GridRow } from 'components/Grid';
import { IntroText } from 'components/IntroText';
import { LiquidButton } from 'components/LiquidButton';
import { useEffect } from 'react';

import { NextLink } from 'components/NextLink';
import NextNprogress from 'nextjs-progressbar';
import { TrackingService } from 'service/tracking/trackingService';
import { COLORS } from 'styles/constants';
import type { IErrorPage } from 'types/ErrorPage';
import { Container } from './PageLevelLayouts/Layouts';
import Image from 'next/image';

interface NotFoundProps {
  errorData?: IErrorPage;
  locale: string;
  errorType: '404' | '500';
}

const ClientNotFoundPage = ({ errorData, locale, errorType }: NotFoundProps) => {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      TrackingService.contentGroups({
        cg1: 'error page',
      });
      TrackingService.pageValues(
        locale.slice(3, 5) || '',
        locale.slice(0, 2).toUpperCase() || '',
        window.location.pathname || '',
      );
    }
  }, []);

  return (
    <>
      <NextNprogress
        color="#29D"
        startPosition={0.3}
        stopDelayMs={200}
        height={3}
        options={{ showSpinner: false }}
      />
      <Container className="flex flex-col justify-center w-full text-center min-h-screen">
        <Grid>
          <GridRow columns={16}>
            <GridItem colStart={6} colSpan={6}>
              {errorType === '404' && (
                <Image src="/images/404_error.png" alt="404 Error" width={2508} height={1138} />
              )}
              {errorType === '500' && (
                <Image src="/images/500_error.png" alt="500 Error" width={2546} height={1138} />
              )}
            </GridItem>
          </GridRow>
        </Grid>
        <IntroText title={errorData?.title} description={errorData?.description} />
        <div className="text-center">
          <NextLink href={errorData?.link?.url || '/'}>
            <LiquidButton
              text={errorData?.link?.displayName || 'Details'}
              height={52}
              width={182}
              color={COLORS.primary}
              textColor={COLORS.white}
            />
          </NextLink>
        </div>
      </Container>
    </>
  );
};

export default ClientNotFoundPage;
